export const inputNumberMinValue = Number.MIN_SAFE_INTEGER;
export const inputNumberPrecision = 2;
export const verbose = 0;
export const showFieldDefinitionAsLabelPrefix = false; // include FieldDefinition name on the FieldFragment label
